import { TaskSupplierComponent } from './task-supplier/task-supplier.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SupplierRoutingModule } from './supplier-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NotificationsSupplierComponent } from './notifications-supplier/notifications-supplier.component';
import { ElectricitySupplierComponent } from './electricity-supplier/electricity-supplier.component';
import { GasSupplierComponent } from './gas-supplier/gas-supplier.component';
import { SupplierContractTaskComponent } from './task-supplier/details/supplier-contract-task/supplier-contract-task.component';
import { SignaturePadModule } from 'angular2-signaturepad';
import { IdentificationDataSupplierComponent } from './identification-data/identification-data-supplier.component';
import { PublicModule } from '../../public/public.module';
import { SharedModule } from '../../shared/shared.module';
import { SupplierInvitationsComponent } from './identification-data/details/supplier-invitations.component';
import { TerminateContractComponent } from './terminate-contract/terminate-contract.component';
import { ElectricityConsumptionPlaceComponent } from './electricity-supplier/consumption-place/electricity-consumption-place.component';
import { GasConsumptionPlaceComponent } from './gas-supplier/consumption-place/gas-consumption-place.component';
import { ExtendsValidityComponent } from './extends-validity/extends-validity.component';

@NgModule({
  declarations: [
    IdentificationDataSupplierComponent,
    NotificationsSupplierComponent,
    TaskSupplierComponent,
    ElectricitySupplierComponent,
    GasSupplierComponent,
    SupplierContractTaskComponent,
    SupplierInvitationsComponent,
    TerminateContractComponent,
    ElectricityConsumptionPlaceComponent,
    GasConsumptionPlaceComponent,
    ExtendsValidityComponent
  ],
  imports: [
    CommonModule,
    NgbModule,
    Ng2SmartTableModule,
    ReactiveFormsModule,
    CKEditorModule,
    FormsModule,
    SupplierRoutingModule,
    SignaturePadModule,
    PublicModule,
    SharedModule
  ],
  exports: [SupplierContractTaskComponent]
})
export class SupplierModule { }
